import {SearchBar,Menu,Button} from 'antd-mobile'
import * as Action_App from '../actions/apps'

class Main extends React.Component {
	componentDidMount(){
		const {actions} = this.props;
		actions.resetParams();
		this.refs.SearchBar.refs.searchInput.focus();
		document.forms[0].action = "";
	}
	render() {
      	return  (
	      	<div className='csm-body-wapper'>
			    <SearchBar ref="SearchBar" placeholder="搜索" showCancelButton onCancel={this.onCancel.bind(this)} onSubmit={this.onSubmit.bind(this)} />
			</div>
	     )
	}
	onSubmit(value) {
		const {router,actions} = this.props;
		actions.resetParams();
		actions.doFliter({searchValue: value});
		document.activeElement.blur();
		router.push("/apps");
	}
	onCancel(value) {
		const {router} = this.props;
		document.activeElement.blur();
    router.push("/apps");
	}
}


function mapStateToProps(state) {
	return {}
}
function mapDispatchToProps(dispatch) {
	return {
		actions: bindActionCreators(Action_App, dispatch)
	}
}

import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
export default connect(mapStateToProps, mapDispatchToProps)(Main);


// WEBPACK FOOTER //
// ./project/components/Search.js